/* ==========================================================================
   TUUFAM AUTOMATED INFINITE SOCIAL OVERHAUL CONTROLLER ENGINE
   ========================================================================== */

document.addEventListener('DOMContentLoaded', () => {
  initTuufamMarqueeRouter();
  initAutomatedCarouselSlides();
});

/* --------------------------------------------------------------------------
   1. INSTAGRAM DEEP LINK NAVIGATION MAPPING
   -------------------------------------------------------------------------- */
function initTuufamMarqueeRouter() {
  const track = document.getElementById('TuufamSocialTrack');
  if (!track) return;

  track.querySelectorAll('.tuufam-canvas').forEach(canvas => {
    canvas.addEventListener('click', () => {
      const targetURL = canvas.getAttribute('data-link');
      if (targetURL && targetURL !== '') {
        window.open(targetURL, '_blank', 'noopener,noreferrer');
      }
    });
  });
}

/* --------------------------------------------------------------------------
   2. AUTOMATED 1.5-SECOND TIME-LAPSE CAROUSEL LOOP (NO ARROWS REQUIRED)
   -------------------------------------------------------------------------- */
function initAutomatedCarouselSlides() {
  const track = document.getElementById('TuufamSocialTrack');
  if (!track) return;

  // Isolates both standard and cloned carousel cards in the infinite marquee track
  const activeCarousels = track.querySelectorAll('.tuufam-canvas.is-carousel');

  activeCarousels.forEach(carousel => {
    const slideContainer = carousel.querySelector('.tuufam-carousel-slides');
    if (!slideContainer) return;

    // Evaluates the child counts inside this unique container frame
    const totalImageSlides = slideContainer.querySelectorAll('img').length;
    if (totalImageSlides < 2) return;

    let currentSlideIndex = 0;
    const extremeUpperIndexBound = totalImageSlides - 1;

    // Automatically transitions slide position maps on a precise 1500ms matrix clock
    setInterval(() => {
      if (currentSlideIndex < extremeUpperIndexBound) {
        currentSlideIndex++;
      } else {
        currentSlideIndex = 0; // Soft fallback to initial tracking state frame
      }
      
      // Hardware-accelerated transformation matrix step
      slideContainer.style.transform = `translate3d(${currentSlideIndex * -100}%, 0, 0)`;
    }, 1500);
  });
}